(function () {
  const data = window.SOXNASkinTestData;
  const unique = (items) => [...new Set(items)];

  function calculate(answers) {
    const scores = Object.fromEntries(Object.keys(data.profiles).map((key) => [key, 0]));
    let safetyScore = 0;
    data.questions.forEach((question) => {
      const selected = answers[question.id] || [];
      selected.forEach((value) => {
        const option = question.options.find(([id]) => id === value);
        if (!option) return;
        Object.entries(option[2] || {}).forEach(([profile, points]) => {
          if (profile === 'safety') safetyScore += points;
          else scores[profile] = (scores[profile] || 0) + points;
        });
      });
    });

    const ranked = Object.entries(scores).sort((a, b) => b[1] - a[1]);
    const primaryKey = ranked[0][1] > 0 ? ranked[0][0] : 'balanced';
    let secondaryKey = ranked.find(([key, value]) => key !== primaryKey && value >= Math.max(3, ranked[0][1] * 0.35))?.[0];
    if (!secondaryKey && primaryKey !== 'balanced') secondaryKey = ranked.find(([key]) => key !== primaryKey)?.[0];
    const safetySelections = answers.safety || [];
    const serious = safetyScore >= 7 || safetySelections.some((id) => ['wounds','spreading','itchy','bleeds'].includes(id));
    const caution = serious || safetyScore >= 4 || ['barrier','sensitive'].includes(primaryKey);
    const keys = unique([primaryKey, secondaryKey].filter(Boolean));
    const profiles = keys.map((key) => ({ key, ...data.profiles[key] }));
    const ingredients = unique(profiles.flatMap((profile) => profile.ingredients)).slice(0, caution ? 5 : 6);
    const avoid = unique(profiles.flatMap((profile) => profile.avoid)).slice(0, 8);
    let productKeys = unique(profiles.flatMap((profile) => profile.products));
    if (caution) productKeys = productKeys.filter((key) => key === 'sheaWhip');
    const products = productKeys.slice(0, 3).map((key) => ({ key, ...data.products[key] }));
    const priorities = unique(profiles.flatMap((profile) => profile.priorities)).slice(0, 4);
    const causes = unique(profiles.flatMap((profile) => profile.causes)).slice(0, 6);
    return { primary: profiles[0], secondary: profiles[1], ingredients, avoid, products, priorities, causes, serious, caution, scores };
  }

  window.SOXNASkinTestLogic = { calculate };
})();
